import getCurrentSocialProfile from 'pages/open-course/common/models/currentSocialProfile';

import * as ThreadsApi from 'bundles/discussions/api/threadsApi';
import { loadingStates } from 'bundles/discussions/constants';
import type { NaptimeError } from 'bundles/naptimejs';

export const clearThreadsCache = (actionContext: $TSFixMe) => actionContext.dispatch('CLEAR_THREADS_CACHE');

export const loadThreads = (
  actionContext: $TSFixMe,
  {
    filterQueryString,
    sort,
    answered,
    pageNum,
    backgroundLoad = false,
    forumType,
    forumId,
    userId,
    includeDeleted,
  }: $TSFixMe
) => {
  if (!backgroundLoad) {
    actionContext.dispatch('START_THREADS_LOAD', {
      filterQueryString,
      sort,
      answered,
      pageNum,
      forumType,
      forumId,
      userId,
    });
  }
  const ThreadsStore = actionContext.getStore('ThreadsStore');
  const hasAlreadyLoadedPage = ThreadsStore.hasLoadedThreadPage({
    filterQueryString,
    sort,
    answered,
    pageNum,
    currentForumId: forumId,
  });

  if (!hasAlreadyLoadedPage) {
    if (!backgroundLoad) {
      actionContext.dispatch('UPDATE_THREADS_LOADING_STATE', loadingStates.LOADING);
    }
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ sort: any; answered: any; page... Remove this comment to see the full error message
    ThreadsApi.load({
      sort,
      answered,
      pageNum,
      filterQueryString,
      forumType,
      forumId,
      userId,
      includeDeleted,
    })
      .then((results) =>
        actionContext.dispatch('RECEIVE_THREADS', {
          results,
          filterQueryString,
          sort,
          answered,
          pageNum,
          currentForumId: forumId,
        })
      )
      .fail((error) => actionContext.dispatch('THREADS_API_ERROR', error))
      .done();
  }
};

export const addThread = (actionContext: $TSFixMe, { options, forumType, forumId }: $TSFixMe) => {
  actionContext.dispatch('THREADS_API_SAVING');
  ThreadsApi.add(options, forumType)
    .then((results) => {
      const splitId = results.elements[0].id.split('~');
      actionContext.dispatch(
        'RECEIVE_NEW_THREAD',
        // we prefer a non-backbone model, so grab the attributes instead of the profile itself
        Object.assign(results.elements[0], {
          creator: getCurrentSocialProfile().attributes,
          forumId,
          questionId: splitId[2],
        })
      );
    })
    .fail((error: NaptimeError | undefined) => {
      if (typeof error === 'object' && error !== null) {
        const errorCode = error?.responseJSON?.errorCode;
        if (errorCode === 'FORUM_POST_INVALID_TERM_EXCEPTION') {
          actionContext.dispatch('THREADS_API_INVALID_TERM_ERROR', error);
        } else if (errorCode === 'FORUM_POST_RATE_LIMIT_REACHED_EXCEPTION') {
          actionContext.dispatch('THREADS_API_RATE_LIMIT_REACHED_ERROR', error);
        } else if (errorCode === 'FORUM_POST_USER_BLOCKED_EXCEPTION') {
          actionContext.dispatch('THREADS_API_USER_BLOCKED_ERROR', error);
        } else {
          actionContext.dispatch('THREADS_API_SAVE_ERROR', error);
        }
      } else {
        actionContext.dispatch('THREADS_API_SAVE_ERROR', error);
      }
    })
    .done();
};
